<style scoped>
  .w-full { width: 100% }
  .p-b-0 {padding-bottom: 0px}
  .adimplente { color: #20bc56; font-weight: bold }
  .tag-red {
    padding: 0.1rem;
    font-size: small;
    background-color: #dd3030;
    color: white;
  }
</style>

<template>
  <section class="container">
    <portal-box>
      <h1 slot="titulo" class="title">Editar Orçamento - Cliente da Base</h1>
      <template slot="menu">
         <b-tag class="tag-red">Valor mínimo {{valorMinimo | moeda}}</b-tag>
      </template>

      <div class="columns">

        <div class="column is-7">

          <div class="columns">
            <div class="column">
              <b-field label="Cliente"
                       :type="$errorType('CLIENTE', errors)"
                       :message="errors.first('CLIENTE')">
                <v-select class="w-full" placeholder="Selecione um cliente"
                          label="label" :loading="loadingCliente" :disabled="true"
                          :options="clientes" v-model="clienteSelecionado" name="CLIENTE"
                          data-vv-as="CLIENTE" v-validate="'required'">
                </v-select>
              </b-field>
            </div>

          </div>

          <div class="columns">
            <div class="column is-2">
              <b-field label="Tabela(R$)"
                       :type="$errorType('COD_TABELA', errors)"
                       :message="errors.first('COD_TABELA')">
                <b-select :loading="loadingTabela" :disabled="!clienteSelecionado"
                          expanded ref="tabela"
                          @input="verificarDescontoSZY"
                          v-model="orcamento.COD_TABELA" name="COD_TABELA"
                          data-vv-as="Tabela(R$)" v-validate="'required'">
                  <option
                    v-for="option in tabelasPreco"
                    :value="option.DA1_CODTAB"
                    :key="option.DA1_CODTAB" v-if="clienteSelecionado ? clienteSelecionado.ATIVO_INATIVO === 'I' ? (option.DA1_CODTAB === '14D' || option.DA1_CODTAB === clienteSelecionado.A1_TABELA) : option.DA1_CODTAB === clienteSelecionado.A1_TABELA : null">
                    {{ option.DA1_CODTAB }}
                  </option>
                </b-select>
              </b-field>
            </div>
          
            <div class="column is-2">
              <b-field label="Tipo frete"
                       :type="$errorType('TIPO_FRETE', errors)"
                       :message="errors.first('TIPO_FRETE')">
                <b-select :loading="loadingTransportadora" :disabled="!clienteSelecionado"
                          data-vv-as="Tipo frete" v-validate="'required'" name="TIPO_FRETE" expanded
                          v-model="orcamento.TIPO_FRETE" @input="verificarEdicaoTransportadora">
                  <option value="C">CIF</option>
                  <option value="F">FOB</option>
                </b-select>
              </b-field>
            </div>
            <div class="column">
              <b-field label="Transportadora"
                       :type="$errorType('COD_TRANS', errors)"
                       :message="errors.first('COD_TRANS')">
                <b-select :loading="loadingTransportadora" :disabled="!transportadoraHabilitada"
                          icon="truck" expanded
                          v-model="orcamento.COD_TRANS" name="COD_TRANS"
                          data-vv-as="Transportadora" v-validate="(transportadoraHabilitada) ? 'required' : ''"
                          placeholder="Selecione uma transportadora">
                  <option
                    v-for="option in transportadoras"
                    :value="option.A4_COD"
                    :key="option.A4_COD">
                    {{ option.A4_COD + " - " + option.A4_NOME }}
                  </option>
                </b-select>
              </b-field>
            </div>

          </div>
          <div class="columns" v-if="parametros.PERMITE_DESC_CABECALHO === 'S'">

              <div class="column is-4" v-if="parametros.DATA_ENTREGA_VISIVEL === 'S'">
                <b-field label="Data de Entrega">
                  <b-datepicker icon="calendar-clock" :disabled="!clienteSelecionado || clienteSelecionado.A1_XXOBRIG === 'I'" expanded
                                :day-names="$dias()" :month-names="$meses()"
                                placeholder="Selecione uma data"
                                :min-date="minDate" v-model="orcamento.DT_ENTREGA">
                  </b-datepicker>
                </b-field>
              </div>

              <div class="column is-4">
                <b-field :label="parametros.LABEL_DESCONTO_1"
                        :type="$errorType('DESCONTO_PEDIDO', errors)"
                        :message="errors.first('DESCONTO_PEDIDO')">
                  <input ref="desc1" v-money="porcentagem" class="input"
                        v-model.lazy="orcamento.DESC1" maxlength="6"
                        @keyup.enter="$refs.desc2.focus"
                        :disabled="true">
                </b-field>
              </div>

              <div class="column is-4">
                <b-field label="Condição de pagamento"
                        :type="$errorType('COND_PAG', errors)"
                        :message="errors.first('COND_PAG')">
                  <b-select v-model="condicaoSelecionada" icon="cash" expanded
                            :disabled="!clienteSelecionado || clienteSelecionado.A1_XXOBRIG === 'I'"
                            data-vv-as="Condição de pagamento" v-validate="'required'" name="COND_PAG"
                            @input="verificarDescontoAdicional($event)"
                            :placeholder="'Selecione uma condição de pagamento'">
                    <option
                      v-for="option in condicoesPagamento"
                      :value="option"
                      :key="option.QZZ_CODIGO">
                      {{ option.QZZ_CODIGO }} - {{ option.QZZ_DESCRI }}
                    </option>
                  </b-select>
                </b-field>
              </div>

              <div class="column" v-if="false">
                <b-field label="Desconto 3">
                  <input ref="desc3" v-model.lazy="orcamento.DESC3"
                          v-money="porcentagem" maxlength="6" class="input"
                          @keyup.enter="$refs.adicionarProduto.focus"
                          :disabled="!clienteSelecionado || !orcamento.COD_TABELA">
                </b-field>
              </div>

              <b-input ref="descontoorcamento" v-model="orcamento.DESCONTO_PEDIDO" type="hidden"/>
            </div>

            <div class="column" v-if="parametros.PERMITE_DESC_CABECALHO === 'S'">
                <b-field :label="parametros.LABEL_DESCONTO_2">
                  <input ref="desc2" v-model.lazy="orcamento.DESC2" maxlength="6"
                          v-money="porcentagem" class="input"
                          @keyup.enter="$refs.desc3.focus" name="DESCONTO_PEDIDO"
                          :disabled="true">
                </b-field>
            </div>

          </div> <!-- columns -->                 

          <div class="column">
            <b-field label="Dados do cliente">
              <section class="dados animated fadeIn">
                <dl>
                  <dt><label>Código</label> {{ (clienteSelecionado && clienteSelecionado.A1_COD) ? clienteSelecionado.A1_COD : ' - ' }}</dt>
                  <dt><label>Fantasia</label>{{ (clienteSelecionado && clienteSelecionado.A1_NREDUZ) ? clienteSelecionado.A1_NREDUZ : ' - ' }}</dt>
                  <dt><label>Endereço</label> {{ (clienteSelecionado && clienteSelecionado.A1_END) ? clienteSelecionado.A1_END + ' - ' + clienteSelecionado.A1_BAIRRO + ' - ' + clienteSelecionado.A1_MUN + ' - ' + clienteSelecionado.A1_EST : ' - '}}</dt>
                  <dt><label>E-mail</label> {{ (clienteSelecionado && clienteSelecionado.A1_EMAIL) ? clienteSelecionado.A1_EMAIL : ' - ' }}</dt>
                  <dt><label>Contato</label> {{ (clienteSelecionado && clienteSelecionado.A1_CONTATO) ? clienteSelecionado.A1_CONTATO : ' - ' }}</dt>
                  <dt v-if="clienteSelecionado && clienteSelecionado.A1_XXOBRIG === 'I'"><label>Situação</label>
                    <button class="button is-danger" @click.stop.prevent="carregarTitlosAberto(clienteSelecionado.A1_COD)">
                      Inadimplente
                    </button>
                  </dt>
                  <dt v-if="clienteSelecionado && clienteSelecionado.A1_XXOBRIG === 'A'">
                    <label>Situação</label>
                    <div type="is-success" class="adimplente">{{(clienteSelecionado && clienteSelecionado.A1_XXOBRIG === 'A') ? 'ADIMPLENTE' : ' - ' }}</div>
                  </dt>
                  <dt><label>Limite de crédito</label> {{ (clienteSelecionado && clienteSelecionado.A1_LC) ? 'R$ ' + clienteSelecionado.A1_LC : ' - ' }}</dt>
                  <dt><label>Limite disponível</label> {{ (clienteSelecionado && clienteSelecionado.LCDISPONIVEL) ? 'R$ ' +  parseFloat(clienteSelecionado.LCDISPONIVEL).toFixed(2) : ' - ' }}</dt>
                </dl>
              </section>
            </b-field>
          </div>
        
        </div>

      <div class="has-text-right m-t">
        <button class="button is-info" :class="{'is-loading': loadingForm}"
                @click.stop.prevent="adicionarProduto" ref="adicionarProduto"
                :disabled="!condicaoSelecionada || !clienteSelecionado || clienteSelecionado.A1_XXOBRIG === 'I'">
          <b-icon icon="plus-box"></b-icon>
          <span>Adicionar produto</span>
        </button>
      </div>

      <b-table :data="orcamento.itens" :loading="loadingForm"
               class="row-button" :selected.sync="linhaSelecionada">

        <portal-lista-vazia :mensagem="'Nenhum produto inserido até o momento'" slot="empty"/>

        <template slot-scope="props">
          <b-table-column label="Nº item">
            <small>{{ props.row.NUMITEM }}.</small>
          </b-table-column>

          <b-table-column label="Código">
            {{ props.row.COD_ITEM }}
          </b-table-column>

          <b-table-column label="Descrição">
            {{ props.row.DESCRICAO }}
          </b-table-column>

          <b-table-column label="Quantidade" numeric>
            <b-field :type="$errorType('quantidade'+props.index, errors)"
                     :message="errors.first('quantidade'+props.index)">
              <b-input ref="QUANT" :name="'quantidade'+props.index"
                       v-model.number="props.row.QUANT" numeric
                       @input="atualizarValoresDoOrcamento"
                       data-vv-as="Quantidade" v-validate="'required|valida_embalagem'">
              </b-input>
            </b-field>
          </b-table-column>

          <b-table-column label="UM/Embalagem">
            {{ props.row.B1_UM }} / {{props.row.EMBALAGEM }}
          </b-table-column>

          <b-table-column label="Valor Tabela" numeric>
            {{ props.row.VALOR_TABELA | moeda }}
          </b-table-column>

          <b-table-column label="Valor Líquido" numeric>
            {{ props.row.VALOR_VENDA | moeda }}
          </b-table-column>         

          <b-table-column label="Comissão" numeric>
            {{ props.row.COMISSAO_ITEM }}%
          </b-table-column>

          <b-table-column label="Total do Produto (Líq.)" numeric>
            {{ (props.row.VALOR_VENDA *  props.row.QUANT) | moeda}}
          </b-table-column>

          <b-table-column label="">
            <b-tooltip label="Remover produto">
              <button class="button is-small is-danger" @click="removerProduto(props.index)">
                <b-icon icon="delete-forever"/>
              </button>
            </b-tooltip>           
          </b-table-column>
        </template>

        <template slot="footer">
          <div class="has-text-right">
            <div class="columns">
              <div class="column p-b-0">
                Valor bruto:
              </div>
              <div class="column is-1 p-b-0">
                {{orcamento.valorPedidoSemDesconto | moeda}}
              </div>
            </div>

            <div class="columns">
              <div class="column p-t-0 p-b-0">
                Descontos (orçamento):
              </div>
              <div class="column is-1 p-t-0 p-b-0">
                {{orcamento.DESCONTO_PEDIDO}}%
              </div>
            </div>

            <div class="columns" v-if="parametros.PERMITE_DESC_ITEM === 'S'">
              <div class="column p-t-0 p-b-0">
                Desconto (produto):
              </div>
              <div class="column is-1 p-t-0 p-b-0">
                {{orcamento.percentualDescontoProduto}}%
              </div>
            </div>

            <div class="columns" v-if="descontoVisivel">
              <div class="column p-t-0 p-b-0">
                Desconto (adicional):
              </div>
              <div class="column is-1 p-t-0 p-b-0">
                {{orcamento.DESC4}}
              </div>
            </div>

            <div class="columns">
              <div class="column p-t-0 p-b-0">
                Total:
              </div>
              <div class="column is-1 p-t-0 p-b-0">
                {{ ((descontoVisivel) ? orcamento.valorPedidoComDescontoAdicional : orcamento.valorPedidoComDescontoCabecalho) | moeda}}
              </div>
            </div>
          </div>
        </template>

      </b-table>

      <div class="columns">

        <div class="column">
          <b-field label="Observações">
            <b-input class="is-fullwidth" type="textarea" v-model="orcamento.OBSV" ref="observacao"
                     :disabled="!clienteSelecionado" maxlength="250" rows="3">
            </b-input>
          </b-field>
        </div>

      </div>

      <footer class="has-text-right">
        <!--<button type="button" class="button" @click="cancelar">Cancelar</button>-->
        <button class="button is-primary is-medium" :class="{'is-loading': loadingForm}"
                @click="salvarOrcamento" :disabled="!clienteSelecionado || clienteSelecionado.A1_XXOBRIG === 'I'">
          <b-icon icon="clipboard-check"></b-icon>
          <span>Salvar Orçamento</span>
        </button>
        <button class="button is-primary is-medium" :class="{'is-loading': loadingForm}"
                @click="converterOrcamento" :disabled="!clienteSelecionado || clienteSelecionado.A1_XXOBRIG === 'I'">
          <b-icon icon="clipboard-check"></b-icon>
          <span>Converter Orçamento</span>
        </button>
      </footer>

    </portal-box>
  </section>
</template>

<script>
  import FormProduto from '../piller/OrcamentoPillerProduto'
  import vSelect from '../../../components/Select'
  import DetalheTitulo from '../../titulo/Lista'
  import {VMoney} from 'v-money'
  import { Validator } from 'vee-validate'

  export default {
    directives: {money: VMoney},
    components: {vSelect},
    created () {
      if (!this.$store.state.parametros || !this.$store.state.parametros.id) {
        this.$air.sair()
        this.$root.$emit('acessar')
      }
    },
    mounted () {
      if (!this.$store.state.parametros || this.$store.state.parametros.length === 0 ||
        this.$store.state.parametros.MENU_SISTEMA.indexOf('ORCAMENTO_CLIENTE_BASE') < 0) {
        this.$router.push('/403')
      } else {
        this.carregarOrcamento(this.$route.params.codigo)
      }
    },
    data () {
      const today = new Date()
      return {
        linhaSelecionada: null,
        segmentoMercado: null,
        condicaoSelecionada: null,
        minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        loadingForm: false,
        loadingCliente: false,
        loadingTransportadora: false,
        loadingTabela: false,
        loadingCondicaoPagamento: false,
        clientes: [],
        clienteSelecionado: null,
        carregaOrcamento: false,
        transportadoras: [],
        transportadoraSelecionada: null,
        tabelasPreco: [],
        transportadoraHabilitada: false,
        descontoVisivel: false,
        orcamento: {},
        porcentagem: {
          decimal: '.',
          thousands: '',
          prefix: '',
          suffix: '%',
          precision: 2,
          masked: false
        },
        valorAnteriorDoPedido: 0,
        condicoesPagamentoApi: [],
        valorMinimo: 0
      }
    },
    methods: {
      validarQuantidade () {
        Validator.extend('valida_embalagem', {
          getMessage: field => `A ${field} precisa ser múltiplo da embalagem.`,
          validate: value => new Promise((resolve) => {
            let emb = (!this.linhaSelecionada || !this.linhaSelecionada.EMBALAGEM) ? 0.01 : this.linhaSelecionada.EMBALAGEM
            resolve({
              valid: value && ((value / emb) % 1) === 0 ||
              ((parseFloat(value) + parseFloat(emb)) / emb) % 1 === 0 && value > 0
            })
          })
        })
      },
      carregarTitlosAberto (codigoCliente) {
        this.$modal.open({
          component: DetalheTitulo,
          canCancel: true,
          width: 'auto',
          props: {codigoCliente}
        })
      },
      validarDescontoAdicional () {
        this.$validator.errors.remove('DESC4')
        if (this.descontoVisivel) {
          let desconto = parseFloat(this.orcamento.DESC4)
          if (desconto > parseFloat(this.orcamento.descontoAdicional)) {
            this.$validator.errors.remove('DESC4')
            this.$validator.errors.add({field: 'DESC4', msg: 'O desconto adicional máximo é de ' + this.orcamento.descontoAdicional + '%'})
            return false
          } else {
            return true
          }
        }
        return true
      },
      carregarOrcamento () {
        this.carregaOrcamento = true
        this.$http.get(this.$URL.ORCAMENTO.BASE + this.$route.params.codigo, this.$header()).then(res => {
          this.orcamento = res.body
          this.orcamento.DT_EMISSAO = new Date(this.orcamento.DT_EMISSAO + ' 00:00:00')
          this.orcamento.DT_ENTREGA = new Date(this.orcamento.DT_ENTREGA + ' 00:00:00')
          // console.log(this.orcamento)
          this.atualizarValoresDoOrcamento(this.orcamento)
          this.listarCondicoesPorTabela(this.orcamento.COD_TABELA)
          this.listarTransportadoras()
          this.listarTabelasDePrecos()
          this.listarClientes()
          this.validarQuantidade()
          this.carregaOrcamento = false
        }, res => {
          this.mensagemFalhaForm(res)
          this.carregaOrcamento = false
        })
      },
      validarTabela (tabela) {
        let result = this.tabelasPreco.filter(t => t.DA1_CODTAB === tabela)
        if (!result || result.length === 0) {
          this.$toast.open({
            message: 'Nenhuma regra de desconto encontrada para tabela: ' + tabela,
            type: 'is-danger'
          })
          return false
        }
        return true
      },
      listarTransportadoras () {
        let orcamentoSalvo = this.orcamento
        this.loadingTransportadora = true
        this.$http.get(this.$URL.TRANSPORTADORA.BASE, this.$header()).then(res => {
          this.transportadoras = res.body
          this.transportadoraSelecionada = this.transportadoras.filter(function (t) {
            return orcamentoSalvo.COD_TRANS === t.A4_COD
          })[0]
          this.loadingTransportadora = false
        }, res => {
          this.mensagemFalhaForm(res)
          this.loadingTransportadora = false
        })
      },
      listarTabelasDePrecos () {
        let orcamentoSalvo = this.orcamento
        this.loadingTabela = true
        this.$http.get(this.$URL.TABELA_PRECO.DISPONIVEIS, this.$header()).then(res => {
          this.tabelasPreco = res.body
          this.tabelaSelecionada = this.tabelasPreco.filter(function (t) {
            return orcamentoSalvo.COD_TABELA === t.DA1_CODTAB
          })[0]
          this.loadingTabela = false
        }, res => {
          this.mensagemFalhaForm(res)
          this.loadingTabela = false
        })
      },
      selecionarCondicoesDePagamento (condPag) {
        this.condicaoSelecionada = this.condicoesPagamento.filter(function (c) {
          return condPag === c.QZZ_CODIGO
        })[0]
      },
      listarClientes () {
        let orcamentoSalvo = this.orcamento
        this.loadingCliente = true
        this.$http.get(this.$URL.CLIENTE.DESBLOQUEADOS, this.$header()).then(res => {
          this.clientes = res.body
          this.clienteSelecionado = this.clientes.filter(function (c) {
            return orcamentoSalvo.COD_CLIENTE === c.A1_COD
          })[0]
          this.selecionarCondicoesDePagamento(this.orcamento.COND_PAG)
          this.loadingCliente = false
        }, res => {
          this.mensagemFalhaForm(res)
          this.loadingCliente = false
        })
      },
      adicionarProduto (produtoSelecionado) {
        if (!this.orcamento.COD_TABELA) {
          this.$dialog.alert({
            title: 'Escolha uma tabela',
            message: 'A escolha de uma tabela de preço é obrigatória.',
            type: 'is-danger',
            onConfirm: () => {
              this.$refs.tabela.focus()
            }
          })
          return
        }
        let itensClone = this.$clonar(this.orcamento.itens)
        let resultado = { selecionado: this.clonarItemOrcamento(produtoSelecionado) }
        let larguraModal = parseInt(this.$store.state.parametros.LARGURA_FORM_PRODUTO)
        this.$modal.open({
          component: FormProduto,
          canCancel: false,
          width: larguraModal,
          props: {
            produto: resultado,
            tabela: this.orcamento.COD_TABELA,
            itens: itensClone,
            parametrosPortal: this.$store.state.parametros,
            descontoCabecalho: this.orcamento.DESCONTO_PEDIDO,
            descontoAdicional: this.orcamento.DESC4,
            embalagens: this.$store.state.embalagens,
            cliente: this.clienteSelecionado
          }
        }).$on('close', () => {
          this.orcamento.itens = itensClone
        })
      },
      removerProduto (index) {
        this.$dialog.confirm({
          message: 'Deseja excluir esse produto?',
          cancelText: 'Não',
          confirmText: 'Sim, Excluir!',
          hasIcon: true,
          type: 'is-danger',
          onConfirm: () => {
            this.orcamento.itens.splice(index, 1)
          }
        })
      },
      converterOrcamento () {
        if (!this.orcamento.itens || this.orcamento.itens.length === 0) {
          this.$dialog.alert({
            title: 'Orçamento Invalido!',
            message: 'Adicione pelo menos um produto',
            type: 'is-dnger'
          })
          return
        }
        let valorPedido = (this.descontoVisivel) ? parseFloat(this.orcamento.valorPedidoComDescontoAdicional) : parseFloat(this.orcamento.valorPedidoComDescontoCabecalho)
        let valorDisponivel = parseFloat(this.clienteSelecionado.LCDISPONIVEL)
        if (this.$store.state.parametros.PED_VALIDA_VALOR_MINIMO === 'S' &&
          valorPedido < this.valorMinimo) {
          this.$dialog.alert({
            title: 'Pedido não autorizado!',
            message: 'O valor não pode ser inferior ao mínimo de: (R$ ' + parseFloat(this.valorMinimo).toFixed(2) + ')',
            type: 'is-danger'
          })
        } else if (this.$store.state.parametros.PED_VALIDA_VALOR_MINIMO === 'C' && valorPedido < this.valorMinimo) {
          this.$dialog.alert({
            title: 'Pedido não autorizado!',
            message: 'O valor não pode ser inferior ao mínimo de: (R$ ' + parseFloat(this.valorMinimo).toFixed(2) + ')',
            type: 'is-danger'
          })
        } else if (this.$store.state.parametros.PED_VALIDA_LIMITE_CREDITO === 'S' && valorDisponivel < valorPedido) {
          this.$dialog.alert({
            title: 'Pedido não autorizado!',
            message: 'O valor do orçamento ultrapassou o límite de credito (R$ ' + valorDisponivel.toFixed(2) + ')',
            type: 'is-danger'
          })
        } else {
          this.$validator.validateAll().then(res => {
            if (res && this.validarDescontoAdicional()) {
              this.$dialog.confirm({
                message: 'Deseja converter este orçamento em pedido?',
                cancelText: 'Não',
                confirmText: 'Sim, Enviar!',
                hasIcon: true,
                type: 'is-info',
                onConfirm: () => {
                  this.loadingForm = true
                  // this.orcamento.CONVERTIDO = 'S'
                  this.$http.post(this.$URL.ORCAMENTO.CONVERTER_ORCAMENTO, this.orcamento, this.$header()).then(res => {
                    this.mensagemSucessoForm('O pedido número <strong>' + this.orcamento.CODIGOWEB + '</strong> foi lançado e aguarda transferência a fábrica.')
                    this.$router.push('/pedido/consulta')
                  }, res => this.mensagemFalhaPedido(res))
                }
              })
            }
          })
        }
      },
      salvarOrcamento () {
        if (!this.orcamento.itens || this.orcamento.itens.length === 0) {
          this.$dialog.alert({
            title: 'Orçamento Invalido!',
            message: 'Adicione pelo menos um produto',
            type: 'is-dnger'
          })
          return
        }
        // console.log('salvarOrcamento', this.orcamento)
        const update = {
          COD_REP: this.orcamento.COD_REP,
          COD_CLIENTE: this.orcamento.COD_CLIENTE,
          CODIGOWEB: this.orcamento.CODIGOWEB,
          CNPJ: this.orcamento.CNPJ,
          COD_LOJA: this.orcamento.COD_LOJA,
          TIPO_FRETE: this.orcamento.TIPO_FRETE,
          COD_TRANS: this.orcamento.COD_TRANS,
          COND_PAG: this.orcamento.COND_PAG,
          DESC1: this.orcamento.DESC1,
          DESC2: this.orcamento.DESC2,
          DESC3: this.orcamento.DESC3,
          DESC4: this.orcamento.DESC4,
          DESCONTO_PEDIDO: this.orcamento.DESCONTO_PEDIDO,
          DT_EMISSAO: this.orcamento.DT_EMISSAO,
          DT_ENTREGA: this.orcamento.DT_ENTREGA,
          DT_VALIDADE: this.orcamento.DT_VALIDADE,
          OBSV: this.orcamento.OBSV,
          COD_TABELA: this.orcamento.COD_TABELA,
          STATUS: this.orcamento.STATUS,
          CONVERTIDO: this.orcamento.CONVERTIDO,
          COD_FILIAL: this.orcamento.COD_FILIAL,
          ORIGEM_CLIENTE: this.orcamento.ORIGEM_CLIENTE,
          itens: this.orcamento.itens,
          valorPedidoSemDesconto: this.orcamento.valorPedidoSemDesconto,
          valorPedidoComDescontoAdicional: this.orcamento.valorPedidoComDescontoAdicional,
          valorPedidoComDescontoCabecalho: this.orcamento.valorPedidoComDescontoCabecalho,
          valorPedidoComDescontoProduto: this.orcamento.valorPedidoComDescontoProduto,
          percentualDescontoProduto: this.orcamento.percentualDescontoProduto,
          valorDescontoProduto: this.orcamento.valorDescontoProduto,
          valorTotalItens: this.orcamento.valorTotalItens
        }
        let valorOrcamentoBruto = parseFloat(this.orcamento.valorPedidoSemDesconto)
        if (valorOrcamentoBruto < parseFloat(this.valorMinimo)) {
          this.$dialog.alert({
            title: 'Orçamento não autorizado!',
            message: 'O valor não pode ser inferior ao mínimo de: (R$ ' + parseFloat(this.valorMinimo).toFixed(2) + ')',
            type: 'is-danger'
          })
        } else {
          this.$validator.validateAll().then(res => {
            if (res && this.validarDescontoAdicional()) {
              this.$dialog.confirm({
                message: 'Deseja salvar o orçamento?',
                cancelText: 'Não',
                confirmText: 'Sim, Salvar!',
                type: 'is-info',
                onConfirm: () => {
                  this.loadingForm = true
                  this.$http.put(this.$URL.ORCAMENTO.BASE + this.orcamento.CODIGOWEB, update, this.$header()).then(res => {
                    this.mensagemSucessoForm('O orcamento número <strong>' + this.orcamento.CODIGOWEB + '</strong> foi salvo com sucesso!')
                    this.$router.push('/orcamento/consulta')
                  }, res => {
                    this.mensagemFalhaPedido(res)
                  })
                }
              })
            }
          })
        }
      },
      toast (res) {
        let msg = res.body.message ? res.body.message : res.body
        let tipo
        switch (res.status) {
          case 401:
            tipo = 'is-danger'
            msg = 'Token inválido! Favor logar novamente.'
            break
          case 0:
          case 404:
            tipo = 'is-warning'
            msg = 'Ops! Nosso servidor está offline, tente novamente mais tarde.'
            break
          case 422:
          case 500:
            tipo = 'is-danger'
            break
          case 200:
            tipo = 'is-info'
            break
          case 201:
            tipo = 'is-success'
            break
        }
        this.$toast.open({
          message: msg,
          type: tipo,
          duration: 4 * 1000
        })
      },
      mensagemSucessoForm (msg) {
        this.loadingForm = false
        this.$dialog.alert({
          title: 'Orçamento salvo com sucesso!',
          message: msg,
          type: 'is-success'
        })
      },
      mensagemFalhaForm (res) {
        this.toast(res)
        this.loadingForm = false
      },
      mensagemFalhaPedido (res) {
        if (res.status === 422) {
          let listaErro = '<ul>'
          let erros = res.body
          Object.keys(erros).forEach(function (erro) {
            erros[erro].forEach(msg => {
              listaErro += '<li class="has-text-danger"><span>' + msg + '</span></li>'
            })
            listaErro += '</ul>'
          })
          this.loadingForm = false
          this.$dialog.alert({
            title: 'Erro',
            message: listaErro,
            type: 'is-danger',
            hasIcon: false
          })
        } else {
          this.toast(res)
        }
      },
      verificarEdicaoTransportadora () {
        if (!this.orcamento || !this.clienteSelecionado) {
          return
        }
        // FOB → mantém como está (usuário escolhe)
        this.transportadoraHabilitada = this.orcamento.TIPO_FRETE === 'F'

        if (this.orcamento.TIPO_FRETE === 'F') {
          this.orcamento.COD_TRANS = null
          return
        }

        // CIF → seta padrão do cliente
        if (this.orcamento.TIPO_FRETE === 'C') {
          this.orcamento.COD_TRANS = this.clienteSelecionado.A1_TRANSP || null
        }
      },
      verificarDescontoAdicional (value) {
        this.$validator.errors.remove('DESC1')
        if (value && this.clienteSelecionado) {
          this.orcamento.COND_PAG = value.QZZ_CODIGO
          this.orcamento.DESC1 = 0
        } else {
          this.orcamento.COND_PAG = ''
          this.orcamento.DESC1 = 0
        }
      },
      verificarDescontoSZY () {
        this.$validator.errors.remove('DESC2')
        if (this.orcamento.COD_TABELA && this.clienteSelecionado) {
          let szy = this.$store.state.szy.filter(zy => zy.ZY_TABELA === this.orcamento.COD_TABELA && zy.ZY_UF === this.clienteSelecionado.A1_EST)
          console.log(szy)
          if (szy.length > 0) {
            this.orcamento.DESC2 = szy[0].ZY_VARPERC * 100
          } else {
            this.orcamento.DESC2 = 0
          }
        } else {
          this.orcamento.DESC2 = 0
        }
      },
      clonarItemOrcamento (item) {
        let clone = {
          B1_UM: (item) ? item.B1_UM : '',
          COD_FILIAL: '01',
          COD_ITEM: (item) ? item.COD_ITEM : '',
          DESC1: (item) ? item.DESC1 : 0,
          DESC2: (item) ? item.DESC2 : 0,
          DESC3: (item) ? item.DESC3 : 0,
          DESC4: (item) ? item.DESC4 : 0,
          DESCONTO_TOTAL: (item) ? item.DESCONTO_TOTAL : 0,
          COMISSAO_ITEM: (item) ? item.COMISSAO_ITEM : 0,
          DESCRICAO: (item) ? item.DESCRICAO : '',
          NUMITEM: (item) ? item.NUMITEM : null,
          QUANT: (item) ? item.QUANT : 0,
          VALOR_TABELA: (item && item.VALOR_TABELA) ? parseFloat(item.VALOR_TABELA).toFixed(2) : 0,
          VALOR_VENDA: (item && item.VALOR_VENDA) ? parseFloat(item.VALOR_VENDA).toFixed(2) : 0
        }
        return clone
      },
      atualizarValoresDoOrcamento (orcamentoSalvo) {
        // this.orcamento.DESCONTO_TOTAL = this.orcamento.DESC1
        let valorTotalSemDesconto = 0
        let valorTotalComDescontoCabecalho = 0
        let valorTotalComDescontoAdicional = 0
        let valorTotalComDescontoProduto = 0
        let valorCabecalhoEProduto = 0
        let percentualDescontoPedido = 0
        let percentualDescontoProduto = 0
        if (this.orcamento.itens && this.orcamento.itens.length > 0) {
          this.orcamento.itens.forEach((item, index) => {
            item.NUMITEM = index + 1
            let descontoProduto = item.DESCONTO_TOTAL ? parseFloat(item.DESCONTO_TOTAL) : 0
            valorTotalComDescontoProduto += (item.VALOR_TABELA - this.$valorDesconto(descontoProduto, item.VALOR_TABELA)) * item.QUANT
            let valorVenda = item.VALOR_TABELA - this.$valorDesconto(parseFloat(this.orcamento.DESC1), item.VALOR_TABELA)
            valorVenda = valorVenda - this.$valorDesconto(parseFloat(this.orcamento.DESC2), valorVenda)
            valorVenda = valorVenda - this.$valorDesconto(parseFloat(this.orcamento.DESC3), valorVenda)
            valorTotalComDescontoCabecalho += valorVenda * item.QUANT
            valorVenda = valorVenda - this.$valorDesconto(parseFloat(item.DESCONTO_TOTAL), item.VALOR_TABELA)
            valorVenda = (valorVenda < 0) ? 0.00 : valorVenda.toFixed(2)
            valorCabecalhoEProduto += valorVenda * item.QUANT
            valorTotalSemDesconto += item.VALOR_TABELA * item.QUANT
            item.VALOR_VENDA = valorVenda - this.$valorDesconto(parseFloat(this.orcamento.DESC4), valorVenda)
            valorTotalComDescontoAdicional = valorCabecalhoEProduto - this.$valorDesconto(parseFloat(this.orcamento.DESC4), valorCabecalhoEProduto)
          })
          percentualDescontoPedido = this.$percentualDesconto(valorTotalSemDesconto - valorTotalComDescontoCabecalho, valorTotalSemDesconto)
          percentualDescontoProduto = this.$percentualDesconto(valorTotalSemDesconto - valorTotalComDescontoProduto, valorTotalSemDesconto)
          this.$refs.descontoorcamento.$emit('input', percentualDescontoPedido)
        } else {
          let valorCalculoDesconto = 100
          valorCalculoDesconto = valorCalculoDesconto - this.$valorDesconto(parseFloat(this.orcamento.DESC1), valorCalculoDesconto)
          valorCalculoDesconto = valorCalculoDesconto - this.$valorDesconto(parseFloat(this.orcamento.DESC2), valorCalculoDesconto)
          valorCalculoDesconto = valorCalculoDesconto - this.$valorDesconto(parseFloat(this.orcamento.DESC3), valorCalculoDesconto)
          percentualDescontoPedido = this.$percentualDesconto((100 - valorCalculoDesconto), 100)
          this.$refs.descontoorcamento.$emit('input', percentualDescontoPedido)
        }
        this.orcamento.valorPedidoSemDesconto = valorTotalSemDesconto.toFixed(2)
        this.orcamento.valorPedidoComDescontoCabecalho = valorCabecalhoEProduto.toFixed(2)
        this.orcamento.valorPedidoComDescontoAdicional = valorTotalComDescontoAdicional.toFixed(2)
        this.orcamento.valorPedidoComDescontoProduto = valorTotalComDescontoProduto.toFixed(2)
        this.orcamento.percentualDescontoProduto = percentualDescontoProduto
        this.validarDescontoAdicional()
      },
      listarCondicoesPorTabela (tabpre) {
        this.loadingCondicaoPagamento = true
        this.$http
          .get(`${this.$URL.REGRA_QZZ.TABELA_PRECO}/${tabpre}`, this.$header())
          .then(res => {
            this.condicoesPagamentoApi = res.body
            this.loadingCondicaoPagamento = false
          })
      },
      buscarValorMinimo (uf) {
        if (!uf) {
          this.valorMinimo = 0
          return
        }

        this.$http
          .get(`${this.$URL.REGRA_QZW.UF}/${uf}`, this.$header())
          .then(res => {
            this.valorMinimo = parseFloat(res.body.QZW_VALOR || 0)
          })
          .catch(() => {
            this.valorMinimo = 0
          })
      }
    },
    computed: {
      parametros () {
        return this.$store.state.parametros
      },
      condicoesPagamento () {
        if (!this.clienteSelecionado) {
          return []
        }
        return this.condicoesPagamentoApi
      }
    },
    watch: {
      'orcamento.DESC1' (value) {
        this.atualizarValoresDoOrcamento()
      },
      'orcamento.DESC2' (value) {
        this.atualizarValoresDoOrcamento()
      },
      'orcamento.DESC3' (value) {
        this.atualizarValoresDoOrcamento()
      },
      'orcamento.DESC4' (value) {
        this.atualizarValoresDoOrcamento()
      },
      'orcamento.itens' (value) {
        this.atualizarValoresDoOrcamento()
      },
      'orcamento.COD_TABELA' (value) {
        if (value) {
          this.listarCondicoesPorTabela(value)
        }
      },
      'orcamento.TIPO_FRETE' (tipo) {
        if (tipo === 'F') {
          this.valorMinimo = 0
        } else if (tipo === 'C' && this.clienteSelecionado && this.clienteSelecionado.A1_EST) {
          this.buscarValorMinimo(this.clienteSelecionado.A1_EST)
        }
      },
      clienteSelecionado (cliente) {
        if (!cliente) {
          this.valorMinimo = 0
          return
        }

        if (this.orcamento.TIPO_FRETE === 'C' && cliente.A1_EST) {
          this.buscarValorMinimo(cliente.A1_EST)
        } else {
          this.valorMinimo = 0
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/orcamento/piller/OrcamentoPillerClienteEdit.vue